import { format } from 'date-fns';
import { MUIDataTableMeta } from 'mui-datatables';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { ITableColumns } from '../../models';

export const formatDateValue = (value: string | number): string => {
  if (!value) return '';
  const date = typeof value === 'string' || typeof value === 'number' ? new Date(value) : null;
  return date && !Number.isNaN(date.getTime()) ? format(date, 'dd.MM.yyyy HH:mm') : String(value);
};

const createDateColumn = (name: string, labelId: string, align: 'left' | 'center' = 'left'): ITableColumns => ({
  name,
  label: labelId,
  options: {
    display: true,
    filter: true,
    filterList: [],
    customBodyRender: (value: string | number) => (
      <div style={{ whiteSpace: 'nowrap', textAlign: align }}>
        {formatDateValue(value)}
      </div>
    ),
  },
});

const createTextColumn = (name: string, labelId: string, align: 'left' | 'center' = 'left'): ITableColumns => ({
  name,
  label: labelId,
  options: {
    display: true,
    filter: true,
    filterList: [],
    customBodyRender: (value: string | number) => (
      <div style={{ whiteSpace: 'nowrap', textAlign: align }}>{value}</div>
    ),
  },
});

export const useColumnDefinition = (): ITableColumns[] => {
  const intl = useIntl();

  return [
    {
      name: 'no',
      label: intl.formatMessage({ id: 'pages.retrieveList.list.no' }),
      options: {
        display: true,
        filter: true,
        filterList: [],
        customBodyRender: (_value: string | number, tableMeta: MUIDataTableMeta) => {
          return `${tableMeta.rowIndex + 1}`;
        },
        setCellProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            left: '0',
            background: 'white',
            zIndex: 100,
          },
        }),
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            left: '0',
            background: 'white',
            zIndex: 101,
          },
        }),
      },
    },
    {
      name: 'status',
      label: intl.formatMessage({ id: 'pages.retrieveList.list.status' }),
      options: {
        display: true,
        filter: true,
        filterList: [],
        customBodyRender: (value: string | number) => {
          return <div style={{ whiteSpace: 'nowrap' }}>{value}</div>;
        },
      },
    },
    {
      name: 'recordLocator',
      label: intl.formatMessage({ id: 'pages.retrieveList.list.bookingid' }),
      options: {
        display: true,
        filter: true,
        filterList: [],
        customBodyRender: (value: string | number, tableMeta: MUIDataTableMeta) => {
          return <Link to={`/tff/order/${value}@${tableMeta.rowData[7]}`}>{value}</Link>;
        },
      },
    },
    createTextColumn('clientPnr', intl.formatMessage({ id: 'pages.retrieveList.list.atcomId' }), 'center'),
    createTextColumn('tfmPnr', intl.formatMessage({ id: 'pages.retrieveList.list.tfmPnr' })),
    createTextColumn('bookingSource', intl.formatMessage({ id: 'pages.retrieveList.list.bookingsrc' }), 'center'),
    createDateColumn('ticketTimeLimit', intl.formatMessage({ id: 'pages.retrieveList.list.ticketTimeLimit' })),
    createDateColumn('outDeparture', intl.formatMessage({ id: 'pages.retrieveList.list.outDeparture' })),
    createDateColumn('returnDeparture', intl.formatMessage({ id: 'pages.retrieveList.list.inDeparture' }), 'center'),
    createDateColumn('createdAt', intl.formatMessage({ id: 'pages.retrieveList.list.createdAt' })),
    createTextColumn('messageType', intl.formatMessage({ id: 'ndc.table.messageType' }), 'center'),
    createTextColumn('decision', intl.formatMessage({ id: 'ndc.table.decision' }), 'center'),
    createDateColumn('receivedAt', intl.formatMessage({ id: 'ndc.table.received' }), 'center'),
    createDateColumn('remindDate', intl.formatMessage({ id: 'ndc.table.remindDate' }), 'center'),
    createDateColumn('autoConfirmDate', intl.formatMessage({ id: 'ndc.table.autoConfirmDate' }), 'center'),
    createTextColumn('classification', intl.formatMessage({ id: 'ndc.table.classification' }), 'center'),
    {
      name: 'version',
      label: 'Version',
      options: {
        display: true,
        filter: true,
        filterList: [],
      },
    },
  ];
};
